import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import LoadingScreen from './components/LoadingScreen';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes ? renderRoutes(route.routes) : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/Error404'))
  },
  {
    path: '/admin',
    // guard: AuthGuard,
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/admin',
        // component: lazy(() => import('./views/admin/Dashboard'))
        component: lazy(() => import('./views/admin/AccountSettings'))
      },
      {
        exact: true,
        path: '/admin/dashboard',
        component: lazy(() => import('./views/admin/Dashboard'))
      },
      {
        exact: true,
        path: '/admin/products',
        component: lazy(() => import('./views/admin/Products'))
      },
      {
        exact: true,
        path: '/admin/pricing-settings',
        component: lazy(() => import('./views/admin/PricingSettings'))
      },
      {
        exact: true,
        path: '/admin/account-settings',
        component: lazy(() => import('./views/admin/AccountSettings'))
      },
      {
        exact: true,
        path: '/admin/appearance',
        component: lazy(() => import('./views/admin/Appearance'))
      },
      {
        exact: true,
        path: '/admin/install',
        component: lazy(() => import('./views/admin/Install'))
      },
      {
        exact: true,
        path: '/admin/product',
        component: lazy(() => import('./views/admin/Product'))
      },
      {
        exact: true,
        path: '/admin/inventory',
        component: lazy(() => import('./views/admin/Inventory'))
      },
      {
        exact: true,
        path: '/admin/inventory/import',
        component: lazy(() => import('./views/admin/Inventory/CreateImport'))
      },
      {
        exact: true,
        path: '/admin/inventory/import/history',
        component: lazy(() => import('./views/admin/Inventory/ImportHistory'))
      },
      {
        exact: true,
        path: '/admin/inventory/import/:id',
        component: lazy(() => import('./views/admin/Inventory/ViewImport'))
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        path: '*',
        layout: MainLayout,
        routes: [
          {
            exact: true,
            path: '/',
            // component: () => <Redirect to="/admin/dashboard" />
            component: () => <Redirect to="/admin/pricing-settings" />
          },
          {
            component: () => <Redirect to="/404" />
          }
        ]
      }
    ]
  }
];

export const getNavigationLinks = () => {
  return [
    // {
    //   label: "Dashboard",
    //   destination: "/admin/dashboard"
    // },
    //TODO remove after functionality is clear
    // {
    //   label: "Products",
    //   destination: "/admin/products"
    // },
    // {
    //   label: "Pricing Settings",
    //   destination: "/admin/pricing-settings"
    // },
    {
      label: "Account Settings",
      destination: "/admin/account-settings"
    },
    //TODO remove after functionality is clear
    // {
    //   label: "Suppliers",
    //   destination: "/admin/suppliers"
    // },
    {
      label: "Inventory",
      destination: "/admin/inventory"
    },
    {
      label: "Appearance",
      destination: "/admin/appearance"
    },
    {
      label: "Install",
      destination: "/admin/install"
    },
  ]
}

export default routes;
